/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.command.EngineCommandOutcome
*/
export var EngineCommandOutcome;
(function (EngineCommandOutcome) {
    EngineCommandOutcome["OK"] = "OK";
    EngineCommandOutcome["UNKNOWN"] = "UNKNOWN";
    EngineCommandOutcome["ERROR"] = "ERROR";
})(EngineCommandOutcome || (EngineCommandOutcome = {}));
//# sourceMappingURL=EngineCommandOutcome.js.map